<app-hero-banner></app-hero-banner>
<app-intro></app-intro>
<!-- <app-products></app-products> -->
<!-- <app-ifp></app-ifp> -->
<app-live-activities *ngIf="liveIsActive"></app-live-activities>
<app-advisors></app-advisors>
<app-class-glimpses></app-class-glimpses>
<app-mastros></app-mastros>
<!-- <app-genre-unveiled></app-genre-unveiled> -->
<app-at-school></app-at-school>
<app-virsa-insight></app-virsa-insight>
<!-- <app-aip></app-aip> -->
<app-express-curiosity></app-express-curiosity>
<app-testimonials></app-testimonials>
<app-about-us></app-about-us>